import { useQuery } from '@apollo/client';
import {
    GroverWorkEnabledQuery,
    GroverWorkEnabledQueryVariables,
    Maybe,
} from 'ggApp/types/graphql';
import GroverWorkEnabled from 'ggApp/shared/queries/groverWorkEnabled.graphql';

type UseGroverWorkEnabledReturn = {
    groverWorkEnabled?: boolean;
};

export const useGroverWorkEnabled = (
    companyId: Maybe<string> | undefined,
): UseGroverWorkEnabledReturn => {
    const { data } = useQuery<GroverWorkEnabledQuery, GroverWorkEnabledQueryVariables>(
        GroverWorkEnabled,
        {
            variables: {
                companyId,
            },
            skip: !companyId,
        },
    );
    return {
        groverWorkEnabled: data?.company?.businessDashboard?.enabled ?? false,
    };
};
